import React from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import InputField from 'components/v2/input-field/input-field';

const localeKeyPrefix = 'shopify.settings.basicSettingsSection.form';

const StoreUrlField = props => {
  const { initialValue, ...other } = props;
  return (
    <InputField
      {...other}
      placeholder={`${I18n.t(`${localeKeyPrefix}.placeholder.url`)}*`}
      fieldOptions={{
        initialValue,
        rules: [
          {
            required: true,
            message: I18n.t(`${localeKeyPrefix}.validation.urlRequired`),
          },
          {
            required: true,
            pattern: /^[-a-zA-Z0-9_.]+\.myshopify\.com$/,
            message: I18n.t(`${localeKeyPrefix}.validation.urlPatternInvalid`),
          },
        ],
      }}
    />
  );
};

StoreUrlField.propTypes = {
  id: PropTypes.string.isRequired,
  form: PropTypes.shape({}).isRequired,
  initialValue: PropTypes.string,
  disabled: PropTypes.bool,
};

StoreUrlField.defaultProps = {
  initialValue: '',
  disabled: false,
};

export default StoreUrlField;
